// Shared formatters
window.Calc = window.Calc || {};
Calc.format = {
  // 1234567.89 -> "1,234,567.89"
  number(n, decimals = 2) {
    if (n === null || n === undefined || isNaN(n)) return '-';
    return Number(n).toLocaleString('en-MY', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  },

  // 1234.5 -> "RM 1,234.50"
  money(n, decimals = 2) {
    if (n === null || n === undefined || isNaN(n)) return '-';
    const sign = n < 0 ? '-' : '';
    return sign + 'RM ' + Calc.format.number(Math.abs(n), decimals);
  },

  // 0.0282 -> "2.82%"
  percent(rate, decimals = 2) {
    if (rate === null || rate === undefined || isNaN(rate)) return '-';
    return (rate * 100).toFixed(decimals) + '%';
  },

  // parse "1,234.56" or "RM 1,234" back to number
  parseNumber(str) {
    if (typeof str === 'number') return str;
    if (!str) return 0;
    const cleaned = String(str).replace(/[^\d.\-]/g, '');
    const n = parseFloat(cleaned);
    return isNaN(n) ? 0 : n;
  },
};
